<template>
  <div class="parent-child-checks_box">
    <template v-if="reloadKey">
      <div v-for="(parent, index) in parents" :key="index">
        <p class="bold_label">
          <input type="checkbox" v-model="parent.isSelected"  @change="setSelectedParentValue(parent, parent.isSelected)">
          {{parent.displayName}}
        </p>
        <span :class="isVisibleChildren ? '' : 'pc_none sp_none'" v-for="(child, childIndex) in parent.children" :key="childIndex">
          <input type="checkbox" v-model="child.isSelected" @change="setSelectedParentValueTriggerChild(parent, child.isSelected)">
          <span>{{child.displayName}}</span>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    name: "ParentChildChecksBox",

    props: {
      propParents: {
        type: Object,
        required: true
      },
      reloadKey: {
        type: Boolean,
      },
      isVisibleChildren: {
        type: Boolean,
        required: true
      }
    },

    data() {
      return {
        parents: this.propParents
      }
    },

    methods: {
      setSelectedParentValue(parent, value) {
        this.parents[parent.name] = Object.assign({}, this.parents[parent.name], {['isSelected']: value});

        for (let [child_key] of Object.entries(parent.children)) {
          this.setSelectedChildValue(parent, parent.children[child_key], value)
        }
      },

      setSelectedChildValue(parent, child, value) {
        this.parents[parent.name].children[child.name] = Object.assign({}, this.parents[parent.name].children[child.name], {['isSelected']: value});
      },

      /**
       * 子要素を押下したときに起動し、トリガーとする親要素のチェック操作を行う
       *
       * 1. どれかの子要素が点灯したとき => 親要素を点灯する
       *
       * @param parent
       * @param value
       */
      setSelectedParentValueTriggerChild(parent, value) {
        if (value && !this.parents[parent.name]['isSelected']) {
          this.parents[parent.name] = Object.assign({}, this.parents[parent.name], {['isSelected']: true});
        }
      },

    }
  }
</script>

<style lang="scss" scoped>
  .parent-child-checks_box {
    margin-left: 4rem;

    > div > span {
      margin-left: 2rem;

      > input {
        margin-right: 0.3rem;
      }
    }

    @media screen and (max-width: 767px) {
      max-width: 100%;

      > div {
        display: flex;
        flex-flow: column;
      }
    }
  }
</style>